document.addEventListener("DOMContentLoaded", function() {
  // --- A. CONSENT PRÜFUNG ---
  if (window.Shopify && window.Shopify.customerPrivacy && !window.Shopify.customerPrivacy.userCanBeTracked()) return;

  const urlParams = new URLSearchParams(window.location.search);
  const utmSource = urlParams.get('utm_source');
  const utmMedium = urlParams.get('utm_medium');
  const utmId = urlParams.get('utm_id');
  const klarSource = urlParams.get('klar_source');
  const klarAdid = urlParams.get('klar_adid');

  // --- B. BEDINGUNG PRÜFEN ---
  // Nur speichern, wenn das exakte neue Meta-Setup in der URL vorhanden ist
  if (utmSource === 'meta' && utmMedium === 'paid_social' && utmId && klarSource === 'meta' && klarAdid) {
    
    const attributionData = {
      'utm_source': utmSource,
      'utm_medium': utmMedium,
      'utm_campaign': urlParams.get('utm_campaign') || '',
      'utm_term': urlParams.get('utm_term') || '',
      'utm_content': urlParams.get('utm_content') || '',
      'utm_id': utmId,
      'klar_source': klarSource,
      'klar_adid': klarAdid
    };

    // Im First-Party Browser-Speicher (Session) ablegen
    sessionStorage.setItem('vegavero_meta_klar_attr', JSON.stringify(attributionData));
  }

  // --- C. IN SHOPIFY CART ATTRIBUTES SCHREIBEN ---
  const storedData = sessionStorage.getItem('vegavero_meta_klar_attr');
  
  if (storedData) {
    const attributesToSave = JSON.parse(storedData);
    
    // Wir prüfen, ob wir das in dieser Session schon an Shopify gesendet haben, um API-Calls zu sparen
    if (!sessionStorage.getItem('vegavero_cart_updated_with_attr')) {
      
      // Nutze die korrekte Route, falls der Shop Unterordner für Sprachen hat (z.B. /it/)
      const cartUrl = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/update.js';

      fetch(cartUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: attributesToSave })
      })
      .then(response => response.json())
      .then(data => {
        console.log('Vegavero Attribution: Attributes successfully added to cart.');
        sessionStorage.setItem('vegavero_cart_updated_with_attr', 'true');
      })
      .catch(error => console.error('Vegavero Attribution Error:', error));
    }
  }
});